// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as CommonHooks$OrcaPaymentPage from "../Hooks/CommonHooks.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as SamsungPayHelpers$OrcaPaymentPage from "../Utilities/SamsungPayHelpers.bs.js";

function SamsungPayComponent(props) {
  var sessionObj = props.sessionObj;
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var isSamsungPayReady = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isSamsungPayReady);
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var options = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var updateSession = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.updateSession);
  var setIsShowOrPayUsing = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isShowOrPayUsing);
  var areOneClickWalletsRendered = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.areOneClickWalletsRendered);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var iframeId = match.iframeId;
  var status = CommonHooks$OrcaPaymentPage.useScript("https://img.mpay.samsung.com/gsmpi/sdk/samsungpay_web_sdk.js", undefined);
  var isWallet = props.walletOptions.includes("samsung_pay");
  var componentName = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  var intent = PaymentHelpers$OrcaPaymentPage.usePaymentIntent(loggerState, "Samsungpay");
  var isTestMode = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isTestMode);
  var match$1 = PaymentUtils$OrcaPaymentPage.useNonPiiAddressData();
  var pinCode = match$1.pinCode;
  var state = match$1.state;
  var country = match$1.country;
  var match$2 = options.wallets.style.height;
  var heightType = match$2[4];
  var height;
  height = heightType.TAG === "SamsungPay" ? heightType._0 : 48;
  SamsungPayHelpers$OrcaPaymentPage.useHandleSamsungPayResponse(intent, undefined, isWallet);
  var onSamsungPaymentButtonClick = function (param) {
    if (isTestMode) {
      console.warn("Samsung Pay button clicked in test mode - interaction disabled");
      return loggerState.setLogInfo("Samsung Pay button clicked in test mode - interaction disabled", "SAMSUNG_PAY", undefined, undefined, undefined, undefined, "SAMSUNG_PAY");
    } else {
      loggerState.setLogInfo("SamsungPay Button Clicked", "SAMSUNG_PAY", undefined, undefined, undefined, undefined, "SAMSUNG_PAY");
      PaymentUtils$OrcaPaymentPage.emitPaymentMethodInfo("wallet", "samsung_pay", undefined, undefined, undefined, undefined, undefined, country, state, pinCode, undefined, undefined);
      return SamsungPayHelpers$OrcaPaymentPage.handleSamsungPayClicked(Utils$OrcaPaymentPage.getDictFromJson(Core__Option.getOr(sessionObj, null)), componentName, iframeId, options.readOnly, undefined);
    }
  };
  var buttonStyle = {
    onClick: onSamsungPaymentButtonClick,
    buttonStyle: "black",
    type: "buy"
  };
  var addSamsungPayButton = function (param) {
    var paymentClient = new SamsungPay.PaymentClient({
          environment: "PRODUCTION"
        });
    var button = paymentClient.createButton(buttonStyle);
    var spayWrapper = document.getElementById("samsungpay-container");
    spayWrapper.innerHTML = "";
    spayWrapper.appendChild(button);
  };
  React.useEffect((function () {
          if (status === "ready" && isSamsungPayReady && isWallet) {
            setIsShowOrPayUsing(function (param) {
                  return true;
                });
            addSamsungPayButton();
          }
          
        }), [
        status,
        sessionObj,
        isSamsungPayReady
      ]);
  var isRenderSamsungPayButton = isSamsungPayReady && isWallet;
  React.useEffect((function () {
          areOneClickWalletsRendered(function (prev) {
                return {
                        isGooglePay: prev.isGooglePay,
                        isApplePay: prev.isApplePay,
                        isPaypal: prev.isPaypal,
                        isKlarna: prev.isKlarna,
                        isSamsungPay: isRenderSamsungPayButton
                      };
              });
        }), [isRenderSamsungPayButton]);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: isRenderSamsungPayButton,
              children: React.createElement("div", {
                    className: "w-full flex flex-row justify-center rounded-md  [&>*]:w-full [&>button]:!bg-contain",
                    id: "samsungpay-container",
                    style: {
                      height: height.toString() + "px",
                      opacity: updateSession ? "0.5" : "1.0",
                      pointerEvents: updateSession ? "none" : "auto"
                    }
                  })
            });
}

var make = SamsungPayComponent;

export {
  make ,
}
/* react Not a pure module */
